<template>
  <div class="key-indicator">
    <MoreTitle title="主要指标" @click="goPage" />
    <div class="grid-layout edge-padding">
      <RowInfo label="市盈率">
        <template v-slot:label>{{ $t('市盈率') }}<sup>TTM</sup></template>
        {{ $digitjs(quoteExtendData.perTtm).rounded() }}
      </RowInfo>
      <RowInfo label="市净率">{{ $digitjs(quoteExtendData.pbr).rounded() }}</RowInfo>
      <RowInfo label="每股收益">{{ $digitjs(incomeData.epsBasic).rounded() }}</RowInfo>
      <RowInfo label="每股净资产">{{ $digitjs(quoteExtendData.nav).rounded() }}</RowInfo>
      <RowInfo label="营业总收入">{{ $digitjs(incomeData.revenue).convert() }}</RowInfo>
      <RowInfo label="营收同比">{{ $digitjs(incomeData.revenueYoY).unit('%').rounded() }}</RowInfo>
      <RowInfo label="净利润">{{ $digitjs(incomeData.profitAfterTax).convert() }}</RowInfo>
      <RowInfo label="净利润同比">{{ $digitjs(incomeData.profitAfterTaxYoY).unit('%').rounded() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  data() {
    return {
      incomeData: [],
      quoteExtendData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getIncomeData()
    this.getQuoteExtendData()
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.symbol,
          type: 'indicators'
        }
      })
    },
    async getIncomeData() {
      const res = await this.$post(this.$api.f10.us + '/finance/income-basic', {
        symbol: this.symbol,
        reportTypes: ['Q1', 'Q6', 'Q9', 'FY'],
        reportSize: 1
      })
      this.incomeData = res.data?.[0] ?? {}
    },
    async getQuoteExtendData() {
      const res = await this.$post(this.$api.sdk.us + '/quote/extend', {
          symbols: [this.symbol],
          timeMode: 0
        },
        {
          headers: {
            'Org-Data-Enable': 'false'
          }
        }
      )
      this.quoteExtendData = res.data?.[0] ?? {}
    }
  }
}
</script>

<style lang="scss" scoped>
.key-indicator {
  background: var(--bg-color-2);
}
</style>
